import { Collapse, Offcanvas } from 'bootstrap';

function handleOffcanvasEvents(): void {
  const offcanvasOffsetElement = document.querySelector<HTMLElement>('header');
  const offcanvasButton = document.getElementById('headerOffcanvasButton');
  const offcanvas = document.getElementById('headerOffcanvas');

  if (offcanvasOffsetElement && offcanvasButton && offcanvas) {
    offcanvas.addEventListener('show.bs.offcanvas', () => {
      offcanvasButton.classList.add('offcanvas-open');
    });

    offcanvas.addEventListener('hide.bs.offcanvas', () => {
      offcanvasButton.classList.remove('offcanvas-open');
    });
  }
}

function handleMainNavigationEvents(): void {
  const mainNavigationCollapses = document.querySelectorAll<HTMLElement>('.navigation-menu-dropdowns .collapse');
  const mainNavigationItemsContainer = document.querySelectorAll<HTMLElement>('.main-navigation-items');
  let collapseOpenCount = 0;

  if (mainNavigationCollapses.length && mainNavigationItemsContainer.length) {
    mainNavigationCollapses.forEach(collapse => {
      collapse.addEventListener('hide.bs.collapse', () => {
        collapseOpenCount--;
        if (collapseOpenCount <= 0) {
          mainNavigationItemsContainer.forEach(container => container.classList.remove('dropdown-open'));
        }
      });
      collapse.addEventListener('show.bs.collapse', () => {
        collapseOpenCount++;
        if (collapseOpenCount > 0) {
          mainNavigationItemsContainer.forEach(container => container.classList.add('dropdown-open'));
        }
      });
    });
  }
}

function handleKeyboardAndMouseEvents(): void {
  // On escape keypress, collapse all header collapses
  const headerCollapses = document.querySelectorAll<HTMLElement>('header .collapse, .main-navigation-wrapper .collapse');
  if (headerCollapses.length) {
    document.addEventListener('keydown', (event) => {
      if (event?.key === 'Escape' || event?.key === 'Esc') {
        headerCollapses.forEach((headerCollapse) => {
          const collapse = Collapse.getOrCreateInstance(headerCollapse, { toggle: false });
          collapse.hide();
        });
      }
    });
  }

  // On click outside main navigation, close all main navigation collapses
  const mainNavigationWrappers = Array.from(document.querySelectorAll('.main-navigation'));
  const mainNavigationCollapses = document.querySelectorAll<HTMLElement>('.main-navigation .collapse');
  if (mainNavigationWrappers.length && mainNavigationCollapses.length) {
    document.addEventListener('click', (event) => {
      const clickedMainNavigation = mainNavigationWrappers.some(wrapper => wrapper.contains(event.target as Node));
      if (!clickedMainNavigation) {
        mainNavigationCollapses.forEach((mainNavigationCollapse) => {
          const collapse = Collapse.getOrCreateInstance(mainNavigationCollapse, { toggle: false });
          collapse.hide();
        });
      }
    });
  }

  // On click outside header and main navigation, close header offcanvas
  const header = document.querySelector<HTMLElement>('header');
  const headerOffcanvas = document.querySelector<HTMLElement>('#headerOffcanvas');
  if (header && headerOffcanvas) {
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target as Node) && !mainNavigationWrappers.some(wrapper => wrapper.contains(event.target as Node))) {
        const offcanvasInstance = Offcanvas.getOrCreateInstance(headerOffcanvas, { toggle: false });
        offcanvasInstance.hide();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleOffcanvasEvents();
  handleMainNavigationEvents();
  handleKeyboardAndMouseEvents();
});
